import Image from 'next/image';
import type React from 'react';

import logo from './logo.svg';

export const InatoLogo = (
  props: Omit<React.ComponentProps<typeof Image>, 'alt' | 'src'>,
) => <Image alt="inato" src={logo} {...props} />;
